"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeInput = void 0;
var react_1 = __importDefault(require("react"));
var useFormControl_1 = require("../../hooks/useFormControl");
var FormControl_1 = require("../FormControl");
var BaseDateRangeInput_1 = require("./BaseDateRangeInput");
function DateRangeInput(props) {
    var label = props.label, error = props.error, rest = __rest(props, ["label", "error"]);
    var _a = useFormControl_1.useFormControl(props), getFormControlProps = _a.getFormControlProps, getInputProps = _a.getInputProps;
    var inputProps = getInputProps();
    return (react_1.default.createElement(FormControl_1.FormControl, __assign({}, getFormControlProps()),
        react_1.default.createElement(BaseDateRangeInput_1.BaseDateRangeInput, __assign({ invalid: inputProps['aria-invalid'] }, inputProps, rest))));
}
exports.DateRangeInput = DateRangeInput;
//# sourceMappingURL=DateRangeInput.js.map